import { render, staticRenderFns } from "./SwiftSport2021.vue?vue&type=template&id=4cfd2526&"
import script from "./SwiftSport2021.vue?vue&type=script&lang=ts&"
export * from "./SwiftSport2021.vue?vue&type=script&lang=ts&"
import style0 from "./SwiftSport2021.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports